import React, { useContext, useEffect, useState } from 'react'
import { Button, Col, Form, Row, Spinner } from 'react-bootstrap';
import { useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { MultiSelect } from "react-multi-select-component";

import { add_slider, get_country_data, get_region_data, get_slider_tag, update_slider } from '../../../../Controller/actions';
import { NewContext } from '../../../../Context/NewContext';

import './sliderform.css';

export const SliderForm = ({ title }) => {
    const navigate = useNavigate();
    const { state } = useLocation();
    const { isLoading, setIsLoading, validated, setValidated, updatedData, setUpdatedData, capitalalizeFirstletter, updateStateAryData } = useContext(NewContext);
    // console.log(state, '----state');
    const [slider, setSlider] = useState({
        name: state ? state.name : "",
        link: state ? state.link : "",
        orientation: state ? state.orientation : "portrait",
        from_flg: state ? state.from_flg : "",
        sliderTag: state ? state.sliderTag : "",
        country: state ? state.country : [],
        region: state ? state.region : [],
        priority: state ? state.priority : "",
        isActive: state ? state.isActive == undefined ? false : state.isActive : false,
    });
    const [imgObj, setImgObj] = useState({ previewSlider: state ? state.preview : "" });
    const [tag, setTag] = useState([]);
    const [country, setCountry] = useState([]);
    const [region, setRegion] = useState([]);

    const [multiThemeCountry, setMultiThemeCountry] = useState([]);
    const [multiThemeRegion, setMultiThemeRegion] = useState([]);

    const getTagFunc = async () => {
        try {
            const tagData = await get_slider_tag(1, "", "", { isActive: true });
            const countryData = await get_country_data();
            const regionData = await get_region_data();
            if (tagData.status && countryData.status && regionData.status) {
                setTag(tagData.data);
                // setCountry(countryData.data);
                // setRegion(regionData.data);

                countryData.data.map(_ele => setCountry(_prev => [..._prev, { value: _ele.code, label: capitalalizeFirstletter(_ele.name), name: 'country' }]))
                regionData.data.map(_ele => setRegion(_prev => [..._prev, { value: _ele.name.toLowerCase(), label: capitalalizeFirstletter(_ele.name), name: 'region' }]))
                if (state) {
                    let oldCountryData = updateStateAryData(state?.country, countryData.data, 'country');
                    let oldRegionData = updateStateAryData(state?.region, regionData.data, 'region');
                    setMultiThemeCountry(oldCountryData);
                    setMultiThemeRegion(oldRegionData);
                } else {
                    console.log(countryData.message || regionData.message);
                }
            } else {
                toast.error(tagData.message);
            }
        } catch (error) {
            console.error(error);
        };
    };

    const handleChange = (e) => {
        if (e.target.name === "country" || e.target.name === "region") {
            let sliderCountryAry = [].slice.call(e.target.selectedOptions).map(item => item.value);
            setUpdatedData({ ...updatedData, [e.target.name]: sliderCountryAry })
            setSlider({ ...slider, [e.target.name]: sliderCountryAry });
        } else {
            setUpdatedData({ ...updatedData, [e.target.name]: e.target.value })
            setSlider({ ...slider, [e.target.name]: e.target.value })
        }
    }
    const handleSelectMultiThemeCountry = (e) => {
        if (e.length > 0) {
            e.map(_ele => {
                let themeMultiSelectAry = [].slice.call(e).map(item => item.value);
                if (_ele.name === 'country') {
                    setMultiThemeCountry(e);
                    setUpdatedData({ ...updatedData, [_ele.name]: themeMultiSelectAry })
                    setSlider({ ...slider, [_ele.name]: themeMultiSelectAry });
                }
            })
        } else {
            setMultiThemeCountry([]);
            setUpdatedData({ ...updatedData, country: [] })
            setSlider({ ...slider, country: [] });
        }
    }
    const handleSelectMultiThemeRegion = (e) => {
        if (e.length > 0) {
            e.map(_ele => {
                let themeMultiSelectAry = [].slice.call(e).map(item => item.value);
                if (_ele.name === 'region') {
                    // console.log(themeMultiSelectAry, '====>>>> region');
                    // console.log(e, '====>>>> region');
                    setMultiThemeRegion(e);
                    setUpdatedData({ ...updatedData, [_ele.name]: themeMultiSelectAry })
                    setSlider({ ...slider, [_ele.name]: themeMultiSelectAry });
                }
            })
        } else {
            setMultiThemeRegion([]);
            setUpdatedData({ ...updatedData, region: [] })
            setSlider({ ...slider, region: [] });
        }
    }

    const handleFileInput = (e) => {
        // console.log(e.target.name, '--', e.target.files[0]);
        // if (e.target.files[0].size > 5242880) {
        //     toast.error(`${e.target.name.charAt(0).toUpperCase() + e.target.name.slice(1)} must less than 5 MB!`);
        // } else {
        setImgObj({ ...imgObj, [e.target.name]: URL.createObjectURL(e.target.files[0]) });
        setUpdatedData({ ...updatedData, [e.target.name]: e.target.files[0] })
        setSlider({ ...slider, [e.target.name]: e.target.files[0] });
        // }
    }

    let handleSwitch = (e) => {
        // console.log(`${e.target.name} : ${e.target.value}`);
        setUpdatedData({ ...updatedData, [e.target.name]: slider[e.target.name] ? false : true })
        setSlider({ ...slider, [e.target.name]: slider[e.target.name] ? false : true })
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        const form = e.currentTarget;
        if (form.checkValidity() === false) {
            e.preventDefault();
            e.stopPropagation();
            setValidated(true);
            return;
        }
        let createUpdateSlider;
        setIsLoading(true);
        if (state) {
            createUpdateSlider = await update_slider({ ...updatedData, country: slider.country, region: slider.region }, state._id)
        } else {
            createUpdateSlider = await add_slider(slider)
        }
        setIsLoading(false);
        if (createUpdateSlider) {
            const { message, status } = createUpdateSlider;
            if (status) {
                toast.success(message);
                navigate("/sliders");
                setSlider({
                    name: "",
                    link: "",
                    orientation: "portrait",
                    from_flg: "",
                    sliderTag: "",
                    country: [],
                    region: [],
                    priority: "",
                    isActive: false,
                });
                setImgObj({ previewSlider: "" })
                setValidated(false);
            } else {
                toast.error(message);
            };
        }
    }

    useEffect(() => {
        getTagFunc();
    }, [])

    useEffect(() => {
        document.title = `Emoji Keyboard | ${title}`;
        setUpdatedData({});
    }, []);

    return (
        <div className='addslider-main p-3'>
            <div className='sliders-header mb-3 d-flex justify-content-between'>
                <h3>{state ? `Edit Slider` : `Add Slider`}</h3>
            </div>
            <Row>
                <Col lg={3} md={4} sm={6} className="mb-3 mx-auto">
                    <Row className='flex-column'>
                        <Col className='mb-3'>
                            <h6 className='mb-1'>Preview : </h6>
                            <img className='w-100' src={`${imgObj.previewSlider ? imgObj.previewSlider : `../../../assets/images/no-image.png`}`} alt={updatedData.name ? updatedData.name : slider?.name} />
                        </Col>
                    </Row>
                </Col>
                <Col lg={(imgObj || state) && 9}>
                    <Form noValidate validated={validated} onSubmit={handleSubmit} method="POST">
                        <Row className='mb-3'>
                            <Col lg={6} className="mb-3">
                                <Form.Label htmlFor='slider_name' column md={3} sm={4}>Name</Form.Label>
                                <Col><Form.Control id='slider_name' type="text" placeholder="Enter Name" name='name' onChange={handleChange} value={updatedData.name ? updatedData.name : slider.name} required /></Col>
                            </Col>
                            <Col lg={6} className="mb-3">
                                <Form.Label htmlFor='slider_previewSlider' column md={3} sm={4}>Preview</Form.Label>
                                <Col><Form.Control id='slider_previewSlider' type="file" accept='image/*' placeholder="Enter Preview" name='previewSlider' onChange={handleFileInput} required={state ? false : true} /></Col>
                            </Col>
                            <Col lg={6} className="mb-3">
                                <Form.Label htmlFor='slider_link' column md={3} sm={4}>Link</Form.Label>
                                <Col><Form.Control id='slider_link' type="text" placeholder="Enter Link" name='link' onChange={handleChange} value={updatedData.link ? updatedData.link : slider.link} /></Col>
                            </Col>
                            <Col lg={6} className="mb-3">
                                <Form.Label htmlFor='slider_orientation' column md={3} sm={4}>Orientation</Form.Label>
                                <Col>
                                    <Form.Check
                                        inline
                                        label="Portrait"
                                        name="orientation"
                                        type={"radio"}
                                        id={`inline-radio-portrait`}
                                        value="portrait"
                                        onChange={handleChange}
                                        checked={updatedData.orientation === "portrait" || slider?.orientation === "portrait"}
                                        role="button"
                                        required
                                    />
                                    <Form.Check
                                        inline
                                        label="Landscape"
                                        name="orientation"
                                        type={"radio"}
                                        id={`inline-radio-landscape`}
                                        value="landscape"
                                        onChange={handleChange}
                                        checked={updatedData.orientation === "landscape" || slider?.orientation === "landscape"}
                                        role="button"
                                        className='ms-3'
                                        required
                                    />
                                    {/* <Form.Control id='slider_orientation' type="text" placeholder="Enter orientation" /> */}
                                </Col>
                            </Col>
                            <Col lg={6} className="mb-3">
                                <Form.Label htmlFor='slider_from_flg' column md={3} sm={4}>From Flg</Form.Label>
                                <Col><Form.Control id='slider_from_flg' type="text" placeholder="Enter From Flg" name='from_flg' onChange={handleChange} value={updatedData.from_flg ? updatedData.from_flg : slider.from_flg} /></Col>
                            </Col>
                            <Col lg={6} className="mb-3">
                                <Form.Label htmlFor='slider_sliderTag' column md={3} sm={4}>Slider Tag</Form.Label>
                                {/* <Col><Form.Control id='slider_sliderTag' type="text" placeholder="Enter Slider Tag" name='sliderTag' onChange={handleChange} value={slider.sliderTag} /></Col> */}
                                <Col>
                                    <Form.Select id='slider_sliderTag' name='sliderTag' onChange={handleChange} value={updatedData.sliderTag ? updatedData.sliderTag : slider.sliderTag} required>
                                        <option value={""} className='text-muted'>Select Tag</option>
                                        {tag.map((_ele, i) => <option key={i} value={_ele.name.toLowerCase()}>{_ele.name}</option>)}
                                    </Form.Select>
                                </Col>
                            </Col>
                            <Col lg={6} className="mb-3">
                                <Form.Label htmlFor='slider_country' column md={3} sm={4}>Country</Form.Label>
                                <Col>
                                    {/* <Form.Select multiple name='country' onChange={handleChange} value={updatedData.country ? updatedData.country : slider.country} required>
                                        <option value={""} className='text-muted'>Select Countries</option>
                                        {country?.map((_ele, i) => <option key={i} value={_ele.code}>{_ele.name}</option>)}
                                    </Form.Select> */}
                                    {
                                        country && country.length > 0 &&
                                        <MultiSelect
                                            options={country}
                                            value={multiThemeCountry}
                                            onChange={handleSelectMultiThemeCountry}
                                            hasSelectAll={true}
                                            ClearSelectedIcon={null}
                                        />
                                    }
                                </Col>
                            </Col>
                            <Col lg={6} className="mb-3">
                                <Form.Label htmlFor='slider_region' column md={3} sm={4}>Region</Form.Label>
                                <Col>
                                    {/* <Form.Select multiple name='region' onChange={handleChange} value={updatedData.region ? updatedData.region : slider.region} required>
                                        <option value={""} className='text-muted'>Select Regions</option>
                                        {region?.map((_ele, i) => <option key={i} value={_ele.name.toLowerCase()}>{_ele.name}</option>)}
                                    </Form.Select> */}
                                    {
                                        region && region.length > 0 &&
                                        <MultiSelect
                                            options={region}
                                            value={multiThemeRegion}
                                            onChange={handleSelectMultiThemeRegion}
                                            hasSelectAll={true}
                                            ClearSelectedIcon={null}
                                        />
                                    }
                                </Col>
                            </Col>
                            <Col lg={6} className="mb-3">
                                <Form.Label htmlFor='slider_priority' column md={3} sm={4}>Priority</Form.Label>
                                <Col>
                                    <Form.Control id='slider_priority' type="number" placeholder="Enter Priority" name='priority' onChange={handleChange} value={updatedData.priority ? updatedData.priority : slider.priority} required />
                                </Col>
                            </Col>
                            <Col lg={6} className="mb-3">
                                <Form.Label htmlFor='slider_isActive' column md={3} sm={4}>Active</Form.Label>
                                <Col><Form.Check type="switch" id="slider_isActive" name='isActive' onChange={handleSwitch} checked={updatedData.isActive ? updatedData.isActive : slider.isActive} role="button" /></Col>
                            </Col>
                        </Row>
                        <Row className='justify-content-start'>
                            <Col lg={6}>
                                <Col lg={3} md={3} sm={4}></Col>
                                <Col>
                                    <Button variant="primary" type="submit" className='px-5 me-3' style={{ width: "150px" }}>
                                        {isLoading ? <Spinner animation="border" size="sm" /> : state ? `Update` : `Submit`}
                                    </Button>
                                    {/* <Link to=""> */}
                                    <Button variant="danger" className='w-auto px-5' onClick={() => navigate(-1)}>{`Back`}</Button>
                                    {/* </Link> */}
                                </Col>
                            </Col>
                        </Row>
                    </Form>
                </Col>
            </Row>
        </div>
    )
};

SliderForm.defaultProps = {
    title: "Slider Form"
};

export default SliderForm;